import React from "react";
import moment from "moment";
// import {
// 	Button,
// 	Container,
// 	Divider,
// 	Grid,
// 	Header,
// 	Icon,
// 	Image,
// 	List,
// 	Segment,
// 	Visibility
// } from 'semantic-ui-react';
// import 'semantic-ui-css/semantic.min.css';
// import SiteMenu from '../../components/menu/Menu';
// import cal from './services/cal';
// import jqBootstrapValidation from './services/jqBootstrapValidation';
// import feApp from './services/fe-app';

import aboutPlans from "../../services/images/about/1.jpg";
import aboutDoorsOpen from "../../services/images/about/2.jpg";
import aboutNewLocation from "../../services/images/about/3.jpg";
import aboutNewLogo from "../../services/images/about/1.png";
import aboutMovedLocation from "../../services/images/about/4.jpg";
import Map from "./components/Map";
import Navigation from "./components/Navigation";
import MenuModals from "./components/MenuModals";
import Events from "./components/events/Events";
import EventModal from "./components/events/Modal";
import Blurb from "./components/Blurb";

export default () => pug`

	Navigation

	header(id='header')
		div(className="dot")
			div(className="container")
				div(className="intro-text")
					div(className="intro-heading") Come Roost at 'THE GOOSE'!
					div(className="intro-lead-in") 2620 Clinton Ave W, Ste C, Huntsville, Alabama 35805
					div(className="intro-lead-in" style={fontSize: '22px'}) HAPPY HOUR Monday-Friday 4PM till 7PM!

	Events(limit=3) 

	MenuModals

	div(id="google-map")
		Map

	section(id="about")
		div(className="container")
			div(className="row")
				div(className="col-lg-12 text-center")
					h2(className="section-heading") About
					Blurb
					h3(className="section-subheading text-muted") Hours
					div(className="table-responsive")
									table(className="table table-hover")
										tr
											td Monday - Thursday
											td 4:00PM - 2:00AM
										tr
											td Friday
											td 2:00PM - 2:00AM
										tr
											td Saturday - Sunday
											td 12:00PM - 2:00AM
					h3(className="section-subheading text-muted") Our Story
			div(className="row")
				div(className="col-lg-12")
					ul(className="timeline")
						li
							div(className="timeline-image")
								img(className="img-circle img-responsive" src=aboutPlans alt="")
							div(className="timeline-panel")
								div(className="timeline-heading")
									h4 2009
									h4(className="subheading") Plans start to form
								div(className="timeline-body")
									p(className="text-muted") We found a spot that looks great!
									p(className="text-muted")
										a(href="http://blog.al.com/entertainment-times/2011/06/lone_goose_saloon_not_your_typ.html") Read more on AL.com
						li(className="timeline-inverted")
							div(className="timeline-image")
								img(className="img-circle img-responsive" src=aboutDoorsOpen alt="")
							div(className="timeline-panel")
								div(className="timeline-heading")
									h4 2011
									h4(className="subheading") The Doors Open
								div(className="timeline-body")
									p(className="text-muted") We open our doors for the first time
									p(className="text-muted")
										a(href="http://blog.al.com/entertainment-times/2011/06/lone_goose_saloon_not_your_typ.html") Read more on AL.com
						li
							div(className="timeline-image")
								img(className="img-circle img-responsive" src=aboutNewLocation alt="")
							div(className="timeline-panel")
								div(className="timeline-heading")
									h4 Sept 2015
									h4(className="subheading") New Location Announcement
								div(className="timeline-body")
									p(className="text-muted") We announce our plans to move to Campus #805 (The old Stone Middle School Building)
									p(className="text-muted")
										a(href="http://www.al.com/business/index.ssf/2015/06/lone_goose_saloon_in_huntsvill.html") Read more on AL.com
						li(className="timeline-inverted")
							div(className="timeline-image")
								img(className="img-circle img-responsive" src=aboutNewLogo alt="")
							div(className="timeline-panel")
								div(className="timeline-heading")
									h4 Dec 2015
									h4(className="subheading") A New Logo!
								div(className="timeline-body")
									p(className="text-muted") We reveal our new logo
						li
							div(className="timeline-image")
								img(className="img-circle img-responsive" src=aboutMovedLocation alt="")
							div(className="timeline-panel")
								div(className="timeline-heading")
									h4 Jan 2016
									h4(className="subheading") We Moved Locations
								div(className="timeline-body")
									p(className="text-muted") The new location at Campus #805 (The old Stone Middle School Building) is now open!
									p(className="text-muted")
										a(href="http://www.al.com/business/index.ssf/2016/01/lone_goose_saloon_debuts_today.html") Read more on AL.com
	
						li(className="timeline-inverted")
							div(className="timeline-image")
								img(className="img-circle img-responsive" src=aboutNewLogo alt="")
							div(className="timeline-panel")
								div(className="timeline-heading")
									h4 Oct 2016
									h4(className="subheading") We launched our website!
								div(className="timeline-body")
									p(className="text-muted") There is now a place online for patrons to view our menu and events!
												
						li(className="timeline-inverted")
							div(className="timeline-image")
								div(className="ourStory")
									h4 Be Part Of Our Story!

	section(id="contact")
		div(className="container")
			div(className="row")
				div(className="col-lg-12 text-center")
					h2(className="section-heading") Visit Us
					// h3(className="section-subheading text-muted") for booking or other inquiries
					div(style={paddingTop:'2em'})
						// h2(style={color:'white', paddingTop:'2em', fontSize:'32px', textTransform:'none'}) Phone 
						// hr(style={width:'30%'})
						// h2 
						// 	a(href="tel:1-256-636-1222" style={color:'white', fontSize:'28px', textShadow:'3px 3px 0px rgba(156,0,0,0.3)'}) 256-636-1222
						h2(style={color:'white', paddingTop:'2em', fontSize:'32px', textTransform:'none'}) Location
						hr(style={width:'30%'})
						div(style={width: '50%', margin: '0 auto'})
							h2
								a( target="blank" href='https://goo.gl/maps/XzL4BxzzvA52' style={color:'white', fontSize:'28px', textShadow:'3px 3px 0px rgba(156,0,0,0.3)'}) 2620 Clinton Ave W, Ste C, Huntsville, Alabama
						
			// div(className="row")
			// 	div(className="col-lg-12")
			// 		form(name="sentMessage" id="contactForm" method="POST" action="/")
			// 			div(className="row")
			// 				div(className="col-md-6")
			// 					div(className="form-group")
			// 						input(type="text" className="form-control" placeholder="Your Name *" id="name" name="name" required)
			// 						p(className="help-block text-danger")
			// 					div(className="form-group")
			// 						input(type="email" className="form-control" placeholder="Your Email *" id="email" name="email" required)
			// 						p(className="help-block text-danger")
			// 					div(className="form-group")
			// 						input(type="text" className="form-control" placeholder="Subject *" id="subject"  name="subject" required)
			// 						p(className="help-block text-danger")
			// 				div(className="col-md-6")
			// 					div(className="form-group")
			// 						textarea(className="form-control" placeholder="Your Message *" id="message"  name="message" required)
			// 						p(className="help-block text-danger")
			// 				div(className="clearfix")
			// 				div(className="col-lg-12 text-center")
			// 					//div(className="g-recaptcha" data-sitekey="6Ld0hwkUAAAAAGawO8ix3lnYKti4XUIUX5lspstY")
			// 					button(type="submit" className="btn btn-xl") Send Message 

	footer
		div(className="container")
			div(className="row")
				div(className="col-md-4")
					span(className="copyright") Copyright &copy; Lone Goose Saloon 2016-#{moment().format("YYYY")}
				div(className="col-md-4")
					ul(className="list-inline social-buttons")
						li
							a(href="https://twitter.com/thegoosehsv" target="blank")
								i(className="fa fa-twitter")
						li
							a(href="https://www.facebook.com/lonegoosesaloon" target="blank")
								i(className="fa fa-facebook")
						li
							a(href="https://www.instagram.com/explore/locations/531257879/" target="blank")
								i(className="fa fa-instagram")
				div(className="col-md-4")
					ul(className="list-inline quicklinks")
						li Developed by 
							a(href="http://lostkode.com" target="blank") LostKode

	EventModal
	
	script(type="application/ld+json").
			{"@context" : "http://schema.org","@type" : "Organization","name" : "Lone Goose Saloon","url" : "","logo": "","sameAs" : [ "https://www.facebook.com/lonegoosesaloon","https://twitter.com/thegoosehsv"],"email": "","legalName": "Lone Goose Saloon","location": {"@type": "Place","hasMap": "https://www.google.com/maps/place/Lone+Goose+Saloon/@34.7207105,-86.6086534,15z/data=!4m5!3m4!1s0x0:0xa2c0fb62533b5867!8m2!3d34.7207105!4d-86.6086534"}}
	script(src="https://maps.googleapis.com/maps/api/js?key=AIzaSyAi1rp1LuVZBdZzNLpEnWqOJyN7Wodnt9c&amp;callback=initMap" async="" defer="")
	script(src="//maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js" integrity="sha384-Tc5IQib027qvyjSMfHjOMaLkfuWVxZxUPnCJA7l2mCWNIpG9mGCD8wGNIcPD7Txa" crossorigin="anonymous")
`;



// WEBPACK FOOTER //
// ./src/scenes/landingPage/LandingPage.js